import { useTheme } from '@mui/material';

import {
  hairColorPalette1,
  hairColorPalette2,
  hairColorPalette3,
  hairColorPalette4,
  hairColorPalette5,
  hairColorPalette6,
  hairColorPalette7,
  hairColorPalette8,
} from 'enrollment/assets/AvatarHairColorSvg';
import {
  shirtColorPalette1,
  shirtColorPalette2,
  shirtColorPalette3,
  shirtColorPalette4,
  shirtColorPalette5,
  shirtColorPalette6,
  shirtColorPalette7,
  shirtColorPalette8,
} from 'enrollment/assets/AvatarShirtColorSvg';
import {
  skinColorPalette1,
  skinColorPalette2,
  skinColorPalette3,
  skinColorPalette4,
  skinColorPalette5,
  skinColorPalette6,
  skinColorPalette7,
  skinColorPalette8,
} from 'enrollment/assets/AvatarSkinColorSvg';
import {
  AvatarSvgIcon1,
  AvatarSvgIcon2,
  AvatarSvgIcon3,
  AvatarSvgIcon4,
} from 'enrollment/assets/AvatarSvgIcons';

export const avatarList = [
  {
    id: 'avatarSvgIcon1',
    code: AvatarSvgIcon1,
    name: 'avatar1',
  },
  {
    id: 'avatarSvgIcon2',
    code: AvatarSvgIcon2,
    name: 'avatar2',
  },
  {
    id: 'avatarSvgIcon3',
    code: AvatarSvgIcon3,
    name: 'avatar3',
  },
  {
    id: 'avatarSvgIcon4',
    code: AvatarSvgIcon4,
    name: 'avatar4',
  },
];

export const skinColorPalette = [
  {
    id: 'skinColorPalette1',
    colorCode: '#F7CE4E',
    code: skinColorPalette1,
    name: 'skinColor1',
  },
  {
    id: 'skinColorPalette2',
    colorCode: '#F4D4C9',
    code: skinColorPalette2,
    name: 'skinColor2',
  },
  {
    id: 'skinColorPalette3',
    colorCode: '#E8B09E',
    code: skinColorPalette3,
    name: 'skinColor3',
  },
  {
    id: 'skinColorPalette4',
    colorCode: '#D9937F',
    code: skinColorPalette4,
    name: 'skinColor4',
  },
  {
    id: 'skinColorPalette5',
    colorCode: '#DAA378',
    code: skinColorPalette5,
    name: 'skinColor5',
  },
  {
    id: 'skinColorPalette6',
    colorCode: '#A76D5F',
    code: skinColorPalette6,
    name: 'skinColor6',
  },
  {
    id: 'skinColorPalette7',
    colorCode: '#8A5C4E',
    code: skinColorPalette7,
    name: 'skinColor7',
  },
  {
    id: 'skinColorPalette8',
    colorCode: '#5D3F38',
    code: skinColorPalette8,
    name: 'skinColor8',
  },
];

export const hairColorPalette = [
  {
    id: 'hairColorPalette1',
    colorCode: '#000000',
    code: hairColorPalette1,
    name: 'hairColor1',
  },
  {
    id: 'hairColorPalette2',
    colorCode: '#433530',
    code: hairColorPalette2,
    name: 'hairColor2',
  },
  {
    id: 'hairColorPalette3',
    colorCode: '#7D5547',
    code: hairColorPalette3,
    name: 'hairColor3',
  },
  {
    id: 'hairColorPalette4',
    colorCode: '#BA482A',
    code: hairColorPalette4,
    name: 'hairColor4',
  },
  {
    id: 'hairColorPalette5',
    colorCode: '#757575',
    code: hairColorPalette5,
    name: 'hairColor5',
  },
  {
    id: 'hairColorPalette6',
    colorCode: '#D7B179',
    code: hairColorPalette6,
    name: 'hairColor6',
  },
  {
    id: 'hairColorPalette7',
    colorCode: '#DB5294',
    code: hairColorPalette7,
    name: 'hairColor7',
  },
  {
    id: 'hairColorPalette8',
    colorCode: '',
    code: hairColorPalette8,
    name: 'hairColor8',
  },
];

export const shirtColorPalette = [
  {
    id: 'shirtColorPalette1',
    colorCode: '#49A078',
    code: shirtColorPalette1,
    name: 'shirtColor1',
  },
  {
    id: 'shirtColorPalette2',
    colorCode: '#9CC5A1',
    code: shirtColorPalette2,
    name: 'shirtColor2',
  },
  {
    id: 'shirtColorPalette3',
    colorCode: '#ED6A5A',
    code: shirtColorPalette3,
    name: 'shirtColor3',
  },
  {
    id: 'shirtColorPalette4',
    colorCode: '#BF4342',
    code: shirtColorPalette4,
    name: 'shirtColor4',
  },
  {
    id: 'shirtColorPalette5',
    colorCode: '#F7A1C8',
    code: shirtColorPalette5,
    name: 'shirtColor5',
  },
  {
    id: 'shirtColorPalette6',
    colorCode: '#2EC0F9',
    code: shirtColorPalette6,
    name: 'shirtColor6',
  },
  {
    id: 'shirtColorPalette7',
    colorCode: '#C09BD8',
    code: shirtColorPalette7,
    name: 'shirtColor7',
  },
  {
    id: 'shirtColorPalette8',
    colorCode: '#FFE570',
    code: shirtColorPalette8,
    name: 'shirtColor8',
  },
];

export const defaultAvatarSkinTone = '#DFAA8B';

export const defaultAvatarHairColor = '#2F2E41';

export const defaultAvatarShirtColor = '#B7C3E1';

export const BeneficiariesTotalAmountAllocationValue = '$ 150,000';

export const BeneficiariesTotalPercentageAllocationValue = '100%';
export const VALID_UPLOAD_IMAGE_TYPES = 'image/jpeg, image/png';
export const VALID_UPLOAD_DOCUMENT_TYPES =
  'image/jpeg, image/png, application/pdf';

export const ThemeStatusToBgColorMappingObj = (status: any) => {
  const theme = useTheme();
  const statusToBgColorMappingObj: any = {
    APPROVED: {
      bgColor: theme?.palette?.success?.light,
      borderColor: theme?.palette?.success?.main,
    },
    'AUTO APPROVED': {
      bgColor: theme?.palette?.success?.light,
      borderColor: theme?.palette.success?.main,
    },
    SUBMITTED: {
      bgColor: theme?.palette?.success?.light,
      borderColor: theme?.palette?.success?.main,
    },
    'PENDING REVIEW': {
      bgColor: theme?.palette?.warning?.light,
      borderColor: theme?.palette?.warning?.main,
    },
    REJECTED: {
      bgColor: theme?.palette?.error?.light,
      borderColor: theme?.palette?.error?.main,
    },
    CLOSED: {
      bgColor: theme?.palette?.success?.light,
      borderColor: theme.palette.grey[300],
    },
    EXPIRED: {
      bgColor: theme?.palette?.success?.light,
      borderColor: theme.palette.grey[300],
    },
    VERIFIED: {
      bgColor: theme?.palette?.success?.light,
      borderColor: theme?.palette?.success?.main,
    },
    'BEING VERIFIED': {
      bgColor: theme?.palette?.warning?.light,
      borderColor: theme?.palette?.warning?.main,
    },
    'NOT VERIFIED': {
      bgColor: theme.palette.error.light,
      borderColor: theme.palette.error.main,
    },
    // TODO: add proper colors for REMOVED later
    REMOVED: {
      bgColor: theme?.palette?.success?.light,
      borderColor: theme.palette.grey[300],
    },
  };
  return statusToBgColorMappingObj[status];
};

export const PlanDetailsMilesOptions = [
  { id:1, value: '1' },
  { id:2, value: '5' },
  { id:3, value: '10' },
  { id:4, value: '15' },
  { id:5, value: '20' },
  { id:6, value: '30' },
  { id:7, value: '50' },
  { id:8, value: '60' },
  { id:9, value: '75' },
];


